import { parsePresetPixelSize } from "../../../utils/getTransform";
import { TOOL_PREP_PREVIEW_BG } from "../../../utils/editorEntrySession";
import { WATERMARK_CONTENT_TYPES } from "../watermark/Popup/watermarkSettings";

export function hasActiveResizeSettings(preset) {
  return Boolean(parsePresetPixelSize(preset));
}

export function hasActiveShadowSettings(shadow) {
  return Boolean(shadow?.enabled);
}

export function hasActiveOutlineSettings(outline) {
  return Boolean(outline?.enabled && Number(outline.width) > 0);
}

export function hasActiveBackgroundFillSettings(previewBg) {
  return (
    previewBg === TOOL_PREP_PREVIEW_BG.COLOR ||
    previewBg === TOOL_PREP_PREVIEW_BG.WHITE
  );
}

export function hasActiveWatermarkSettings(watermark) {
  if (!watermark) return false;
  if (watermark.contentType === WATERMARK_CONTENT_TYPES.LOGO) {
    return Boolean(watermark.logoUrl);
  }
  return Boolean(String(watermark.text || "").trim());
}

export function hasActiveBlurSettings(amount) {
  return Math.max(0, Number(amount) || 0) > 0;
}
